import React from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import { white } from 'styles/colors'
import { cover } from 'styles/global'
import * as spacing from 'styles/spacing'
import { media, mediaDown } from 'styles/media'
import { H1, H4, fontWeights, lineHeights } from 'styles/typography'

import Wrapper from 'components/Wrapper'
import Button from 'components/button/Button'

const Container = styled.div`
  position: relative;
  text-align: center;
  color: ${white};
  overflow: hidden;
  background: linear-gradient(90deg, #d09d01 0%, #ad7e01 100%);
  margin-bottom: ${spacing.xLarge};

  ${media.medium`
    text-align: left;
    margin-bottom: 0;
  `};
`

const Outer = styled.div`
  padding-top: 2.5rem;
  padding-bottom: 3rem;

  ${media.small`
    padding-top: 3.5rem;
    padding-bottom: 4rem;
  `};

  ${media.medium`
    padding-top: 5.5rem;
    padding-bottom: 1rem;
  `};

  ${media.large`
    padding-top: 7rem;
  `};

  ${media.xLarge`
    padding-top: 8rem;
    padding-bottom: 2rem;
  `};
`

const Wrap = styled.div`
  position: static;

  ${media.medium`
    display: flex;
    justify-content: space-between;
  `};
`

const Content = styled.div`
  position: static;
  margin-bottom: ${spacing.large};

  ${mediaDown.medium`
    max-width: 460px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.small`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.medium`
    margin-bottom: 0;
    max-width: 540px;
    padding-right: 5%;
    padding-top: 40px;
  `};

  ${media.large`
    padding-top: 64px;
    padding-right: 7.5%;
    max-width: none;
  `};

  ${media.xLarge`
    padding-top: 96px;
  `};
`

const Heading = styled(H1)`
  color: ${white};
  font-family: 'Trim Poster';
  margin-bottom: 0.25em;
  font-size: 32px;
  text-transform: uppercase;

  ${media.small`
    font-size: 40px;
  `};

  ${media.medium`
    font-size: 44px;
    white-space: nowrap;
  `};

  ${media.large`
    font-size: 54px;
  `};

  ${media.xLarge`
    font-size: 60px;
  `};
`

const Subheading = styled(H4)`
  color: ${white};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
  margin-bottom: ${spacing.medium};

  ${media.medium`
    margin-bottom: ${spacing.large};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.xLarge};
  `};
`

const FigureWrap = styled.div`
  position: relative;
  z-index: 10; /* Position above slant */
  flex-shrink: 0;
  margin-bottom: -${spacing.large};

  ${mediaDown.medium`
    max-width: 460px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.small`
    margin-bottom: -${spacing.xLarge};
  `};

  ${media.medium`
    width: 500px;
    margin-right: -24px;
    margin-bottom: 0;
    transform: translateY(-16px);
  `};

  ${media.large`
    width: 610px;
    transform: translateY(-24px);
    margin-right: -48px;
  `};

  ${media.xLarge`
    width: 690px;
    transform: none;
    margin-right: -32px;
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`

const Figure = styled.img`
  object-fit: cover;
  ${cover('absolute')};
`

const Slant = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -1px;
  pointer-events: none;
  max-height: 300px;
`

const StarterBundle = () => (
  <Container>
    <Outer>
      <Wrapper>
        <Wrap>
          <Content>
            <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
              Starter Bundle
            </Heading>
            <Subheading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={400} animateOnce>
              Customise your own starter bundle by selecting one device and one pack of pods for only{' '}
              <strong>$14.99</strong>
            </Subheading>

            <ScrollAnimation animateIn="fadeInUp" offset={0} delay={600} animateOnce>
              <Button
                to="/buy-online/epod-starter-bundle/"
                theme="custom"
                customColor={white}
                variant="outline"
                size="large"
              >
                Try it now
              </Button>
            </ScrollAnimation>
          </Content>
          <FigureWrap as={ScrollAnimation} animateIn="fadeIn" offset={0} delay={600} animateOnce>
            <Figure src={`${process.env.BASE_PATH}/images/home/bundle/bundle.png`} />
          </FigureWrap>
        </Wrap>
      </Wrapper>
    </Outer>
    <Slant src={`${process.env.BASE_PATH}/images/home/bundle/slant.png`} />
  </Container>
)

export default StarterBundle
